import { FormattedMessage } from 'react-intl'

import { Heading } from 'Components/_theme'
import { LanguageDropdown } from 'Components/LanguageDropdown/LanguageDropdown'

export const OfferRecreatedContent = () => (
  <>
    <Heading className="PurchaseContent-heading" size={1}>
      <FormattedMessage id="OfferRecreatedContent_heading" />
    </Heading>

    <div className="PurchaseContent-content">
      <p>
        <FormattedMessage id="OfferRecreatedContent_message" />
      </p>
    </div>

    <LanguageDropdown isLandingPage />
  </>
)
